import { render, staticRenderFns } from "./AdminIcons.vue?vue&type=template&id=7b97b39b&scoped=true"
import script from "./AdminIcons.vue?vue&type=script&lang=js"
export * from "./AdminIcons.vue?vue&type=script&lang=js"
import style0 from "./AdminIcons.vue?vue&type=style&index=0&id=7b97b39b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b97b39b",
  null
  
)

export default component.exports